<template>
  <rand-money :title="title" :cur-class="curClass" />
</template>

<script>
import RandMoney from '@/views/config/rand-conf/rand-money.vue'

export default {
  name: 'RandSpins',
  components: { RandMoney },
  data() {
    return {
      title: '随机体力配置',
      curClass: 'randSpins'
    }
  }
}
</script>

